import { trustupWebsocket } from "@deegital/js-trustup-io-websocket";
import BaseWebsocketListener from "@spa/apps/trustup-pro-base-js/BaseWebsocketListener";
import Opportunity from './models/Opportunity';  
import Worksite from './models/Worksite'; 
import WorksiteFile from './models/WorksiteFile'; 
import WorksiteFileFolder from './models/WorksiteFileFolder';  
import WorksitePhase from './models/WorksitePhase'; 
import WorksiteProfitabilityDocument from './models/WorksiteProfitabilityDocument'; 

export default class WebsocketListener extends BaseWebsocketListener
{

    getModels()
    {
        return [
            Opportunity,
            Worksite,
            // WorksiteFile,
            // WorksiteFileFolder,
            WorksitePhase,
            // WorksiteProfitabilityDocument,
        ];
    }
    
}